module.exports = __webpack_public_path__ + "static/media/README.3878ac02.md";